// global process
import BotBuilderContants from '@src/phrases';

const KEYWORDS = BotBuilderContants.getPhrase;

export const BASE_URL =
  process.env.BASE_URL || `${window.location.origin}/mogambo_api/`;

export const CHANGE = 'CHANGE';
export const CRASH_URL = `${BASE_URL.replace(
  '/mogambo_api',
  ''
)}admin_tools/report_crash/`;

export const ADMIN_BASE_URL = `${BASE_URL.replace(
  '/mogambo_api',
  ''
)}admin_tools/permission/`;

export const ADMIN_ROOT_URL = `${BASE_URL.replace(
  '/mogambo_api',
  ''
)}admin_tools/`;

export const TRACT_DASH = BASE_URL.replace(
  'mogambo_api',
  'admin_tools/tract_dash'
);
export const ACCESS_REQUEST = BASE_URL.replace(
  'mogambo_api',
  'admin_tools/access_request'
);

export const ECT_CREDENTIALS = `ect_credentials/`;
export const METADATA = `metadata/`;
export const INVITE = `invite/`;

export const BOT = {
  OPEN_BOT: 'OPEN_BOT',
};

export const SELF_SERVE_FF_KEY = 'enable_self_serve_features';
export const TOPBAR_ROUTE_CONFIG = {
  CS: '/mogambo',
  IA: '/dashboard',
};

export const ROUTES = {
  CREATE_NEW_IVA: '/home_v2/#/create-bot/',
};

export const PERMISSION_LEVELS = {
  BUSINESS_PROMPT_TRIGGER_EDIT_TRANSFER:
    'mogambo_bot_prompt_trigger_edit_transfer',
  BUSINESS_TASK_EDIT_TRANSFER: 'mogambo_business_task_edit_transfer',
  BUSINESS_TEAM_EDIT: 'mogambo_business_team_edit',
  MOGAMBO_ALL_EDIT: 'mogambo_all_edit',
  MOGAMBO_ALL_VIEW: 'mogambo_all_view',
  MOGAMBO_BOT_SAYS_EDIT: 'mogambo_botsays_edit',
  MOGAMBO_BOT_TRANSFER: 'mogambo_bot_transfer',
  TEMPLATES_EDIT: 'templates_edit',
  TEMPLATES_VIEW: 'templates_view',
  SMART_SKILLS_VIEW_EDIT: 'smart_skills_edit', // This will act as permission for both viewing and editing smart skills
  EDIT_ENV_VARIABLES: 'mogambo_create_edit_env',
  EDIT_BUSINESS_DYNAMIC_MESSAGE: 'business_dynamic_message_edit',
  VIEW_BUSINESS_DYNAMIC_MESSAGE: 'business_dynamic_message_view',
};

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PREPROD: 'preprod',
  PRODUCTION: 'production',
};

export const POPUPS = {
  CREATE_BOT: 'create-bot-popup',
  CREATE_NEW_STORY: 'create-new-story-popup',
};

export const OVERLAYS = {
  TABLE_TAGS: 'table-tags-overlay',
};

const MIX_PANEL_PREFIXES = {
  SMART_SKILLS: 'CS_SS-',
  CONVERSATION_STUDIO: 'CS_',
  PREVIEW_TRANSFER: 'CS_PT-',
  BOT_VERSION: 'CS_Bot_Versioning_',
  AB_TEST: 'CS_ABTest_',
  GEN_AI: 'CS_GenAI_',
  WEBGUIDE: 'CS_AISS_',
};

/**
 * MixPanel Events
 * Naming convention - CS_<action>_<feature>_<other_info>

  action → set, delete, create, undelete, activate, deactivate, etc
  feature → bot, node, story, sub-story, etc
 */
export const MIX_PANEL = {
  BOT: {
    BOT_CREATE: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Create_Bot`,
    OPEN_BUSINESS: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Open_Business_From Bot`,
    OPEN_BUSINESS_FROM_LIST: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Open_Business_From List`,
    CONFIRM_BOT_TRANSFER: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Confirm_Bot_Bot Transfer`,
  },

  SIDEBAR: {
    SKILL_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Skill_Icon_Clicked`,
    FAQ_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}FAQ_Icon_Clicked`,
    SMALL_TALK_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Small_Talk_Icon_Clicked`,
    SEARCH_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Search_Icon_Clicked`,
    BM_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Business_Manager_Icon_Clicked`,
    AE_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Agent_Escalation_Icon_Clicked`,
    EDIT_BOT_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Edit_Bot_Icon_Clicked`,
    SMART_SKILL_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Smart_Skill_Icon_Clicked`,
  },

  NODE: {
    CONTEXT_MENU_OPENED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Open_Node_Context Menu`,
    CONTEXT_MENU_ITEM_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Option Click_Node_Context Menu`,
    CONNECTION_ADDED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Connection Add_Node_via Context Menu`,
    ACTIVATED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}node_activated`,
  },

  SMART_SKILLS: {
    // Skillset
    CREATE_SKILLSET: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Create_Skillset`,
    SKILLSET_DEACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Deactivate_Skillset`,
    SKILLSET_ACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Activate_Skillset`,

    // FAQ
    CONFIGURE_FAQ: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Open_Configure FAQ`,

    // Smalltalk
    CONFIGURE_SMALLTALK: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Configure_Smalltalk`,
    SMALLTALK_DEACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Deactivate_Smalltalk`,
    SMALLTALK_ACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Activate_Smalltalk`,

    // Tour
    TOUR_CANCELLED_STEP_1: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Cancel_Tour Step 1`,
    TOUR_STEP_1_NEXT: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Next_Tour Step 1`,
    TOUR_CANCELLED_STEP_2: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Cancel_Tour Step 2`,
    TOUR_STEP_2_NEXT: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Next_Tour Step 2`,
    TOUR_COMPLETED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Complete_Tour`,

    // Skills and Smart Skills
    ADD_SKILL: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Open_Add Skill Drawer`,

    CLOSE_SMART_SKILL_SIDEBAR: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Close_Add Skill Drawer`,
    SEARCH_SMART_SKILL_FOCUSSED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Focus_Search`,
    SEARCH_SMART_SKILL_SEARCHED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Search_Searched`,

    SMART_SKILL_CATEGORY_OPENED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Open_Category`,
    SMART_SKILL_CATEGORY_CLOSED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Close_Category`,
    SMART_SKILL_DETAILS_MODAL_OPENED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Open_Details Modal`,
    SMART_SKILL_DETAILS_MODAL_CLOSED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Close_Details Modal`,
    SMART_SKILL_ADDED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Add_Smart Skill`,
    SMART_SKILL_RENAMED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Rename_Smart Skill`,
    SMART_SKILL_COPIED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Copy_Smart Skill`,
    SMART_SKILL_DEACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Deactivate_Smart Skill`,
    SMART_SKILL_ACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Activate_Smart Skill`,

    CUSTOM_SKILL_COPIED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Copy_Custom Skill`,
    CUSTOM_SKILL_DEACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Deactivate_Custom Skill`,
    CUSTOM_SKILL_RENAMED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Rename_Custom Skill`,
    CUSTOM_SKILL_ADDED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Add_Custom Skill`,
    CUSTOM_SKILL_ACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Activate_Custom Skill`,
    CUSTOM_SKILL_CREATION_OPENED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Open_Custom Skill_Creation`,
    CUSTOM_SKILL_CREATION_CLOSED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Close_Custom Skill_Creation`,
    CUSTOM_SKILL_CREATION_CREATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Create_Custom Skill_Creation`,
    CUSTOM_SKILL_CREATION_DEACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Deactivate_Custom Skill_Creation`,
    CUSTOM_SKILL_CREATION_ACTIVATED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Activate_Custom Skill_Creation`,

    SKILL_PASTED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Paste_Skill`,
    SKILL_PASTE_FAILED: `${MIX_PANEL_PREFIXES.SMART_SKILLS}Copy_Paste_Failed`,
  },
  PREVIEW_TRANSFER: {
    PREVIEW_TRANSFER_TRIGGERED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Open_Preview and Transfer`,
    LOADING_CANCELLED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Close_Loading Modal`,
    EMPTY_SCREEN: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Open_Empty Screen Modal`,
    TOTAL_CONTRIBUTORS: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Show_Total Contributors`,
    ENTITY_CHANGES_PRESENT: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Show_Entity Changes`,
    ENTITY_SECTION_COLLAPSED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Close_Entity Accordion`,
    ENTITY_SECTION_EXPANDED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Open_Entity Accordion`,
    SKILLSET_CHANGES_PRESENT: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Show_Skillset Changes`,
    SKILLSET_SECTION_COLLAPSED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Close_Skillset Accordion`,
    SKILLSET_SECTION_EXPANDED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Open_Skillset Accordion`,
    FAQ_CHANGES_PRESENT: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Show_Faq Changes`,
    FAQ_SECTION_COLLAPSED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Close_Faq Accordion`,
    FAQ_SECTION_EXPANDED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Open_Faq Accordion`,
    SKILL_SECTION_COLLAPSED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Close_Skill Accordion`,
    SKILL_SECTION_EXPANDED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Open_Skill Accordion`,
    TRANSFER_CLICKED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Open_Confirm Publish Modal`,
    TRANSFER_JUMP_OUT: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Close_Confirm Publish Modal`,
    HOVER_ON_YELLOW: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}MouseOver_Modified Changes`,
    HOVER_ON_GREEN: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}MouseOver_New Changes`,
    HOVER_ON_RED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}MouseOver_Removed Changes`,
    HOVER_ON_GREY: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}MouseOver_Child Contains Changes`,
    MERGE_CONFLICT: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Transfer_Merge Conflict`,
    MERGE_CONFLICT_REFRESHED: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}Transfer_Merge Conflict Refreshed`,
    TOTAL_TIME_PAGE: `${MIX_PANEL_PREFIXES.PREVIEW_TRANSFER}User_Total Time On Page`,
  },

  DISAMBIGUATION: {
    SETTINGS_ICON_CLICKED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Disambiguation_Settings_Icon_Clicked`,
    MESSAGE_EDITED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Disambiguation_Message_Edited`,
    MODAL_CLOSED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Disambiguation_Modal_Closed`,
  },

  GLOBAL_CONSTANTS: {
    CREATION: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}GlobalConstant_Creation`,
    DELETION: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}GlobalConstant_Deletion`,
  },

  OMNICHANNEL: {
    ACTIVITY: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}HSL-CRUD-activity`,
    RESET: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}Omnichannel-Reset`,
  },

  BOT_VERSION: {
    CREATION: `${MIX_PANEL_PREFIXES.BOT_VERSION}Created`,
    CREATION_FAILED: `${MIX_PANEL_PREFIXES.BOT_VERSION}Creation_failed`,
    RESTORATION: `${MIX_PANEL_PREFIXES.BOT_VERSION}Restored`,
    RESTORATION_FAILED: `${MIX_PANEL_PREFIXES.BOT_VERSION}Restoration_failed`,
    VERSION_INCREMENTATION: `${MIX_PANEL_PREFIXES.BOT_VERSION}Version_Name_Incremented`,
    VERSION_DECREMENTATION: `${MIX_PANEL_PREFIXES.BOT_VERSION}Version_Name_Decremented`,
  },

  AB_TEST: {
    RHS_OPENED: `${MIX_PANEL_PREFIXES.AB_TEST}Section_Opened`,
    STARTED: `${MIX_PANEL_PREFIXES.AB_TEST}Started`,
    STOPPED: `${MIX_PANEL_PREFIXES.AB_TEST}Stopped`,
  },

  GEN_AI_MODAL: {
    POPUP_OPENED: `${MIX_PANEL_PREFIXES.GEN_AI}GPT_START_NODE_POPUP_SHOWN`,
    SKIP_CLICKED: `${MIX_PANEL_PREFIXES.GEN_AI}GPT_START_NODE_SKIP_CLICKED`,
    GENERATE_CLICKED: `${MIX_PANEL_PREFIXES.GEN_AI}GPT_START_NODE_GENERATE_CLICKED`,
    NODE_CREATED: `${MIX_PANEL_PREFIXES.GEN_AI}GPT_START_NODE_STEP_CREATED`,
  },

  GRAPH_MULTIPLE_STEPS: {
    SELECTION: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}selected-multiple-steps`,
    DRAG: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}dragged-multiple-selected-steps`,
  },

  GRAPH: {
    SHOW_INACTIVE_NODES: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}show_inactive_nodes`,
  },

  BOT_RESPONSES_UPLOAD: {
    DOWNLOAD: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}bot_responses_downloaded`,
    UPLOAD: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}bot_responses_uploaded`,
  },

  BOT_SYNONYMS: {
    DOWNLOAD: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}bot_synonyms_downloaded`,
    UPLOAD: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}bot_synonyms_uploaded`,
  },

  WEBGUIDE: {
    TRAINING_STARTED: `${MIX_PANEL_PREFIXES.CONVERSATION_STUDIO}webguide_training_clicked`,
  },
};

export const GOOGLE_ANALYTICS = {
  CATEGORY: {
    BOT_SAYS: 'Bot Response',
    BOT: 'bot',
    BUSINESS: 'business',
    COPYPASTE: 'copy_paste',
    ENTITY: 'Entity',
    EXTRACT: 'Extract',
    GENERAL_NODES: 'General nodes',
    GENERAL_RESPONSES: 'General responses',
    GRAPH: 'graph',
    NODE_PRIORITY: 'node_priority',
    NODE: 'Step',
    OUTPUT_NODE: 'output_node',
    STORY: 'Skill Set',
    TEMPLATE: 'Template',
    TEST: 'test',
    TOOLTIP: 'tooltip',
    TRAIN: 'train',
    TRANSFER: 'Publish',
    USER_SAYS: 'User Says',
    INTEGRATIONS: 'INTEGRATIONS',
    CONNECTIONS: KEYWORDS('CONNECTION.PLURAL.CAPITALIZE'),
    CODE_EDITOR: 'Code Editor',
    DEBUG: 'Debug',
    EDIT_BOT_GLOSSARY: 'Edit Bot Glossary',
    SMART_VARIANTS: 'Smart Variants',
    SMART_SKILLS: 'Smart Skills',
  },
  EVENTS: {
    BOT_ACTIVATE: 'bot_activate',
    BOT_CREATE: 'bot_create',
    BOT_DEACTIVATE: 'bot_deactivate',
    BOT_EDIT: 'bot_edit',
    BOT_EXTRACTED: 'bot_extracted',
    BOT_SAYS_ADD: 'bot_says_add',
    BOT_SAYS_EDIT: 'bot_says_edit',
    BOT_SAYS_ENTITY: 'bot_says_entity',
    BOT_TRAINED: 'bot_trained',
    BOT_TRANSFER: 'bot_transfer',
    BUSINESS_CREATE_VIA_BOTFLOW: 'business_create_botflow',
    BUSINESS_CREATE_VIA_BUSINESSMANAGER: 'business_create_bizmngr',
    BUSINESS_EDIT: 'business_edit',
    BUSINESS_TRANSFER: 'business_transfer',
    CLICK: 'click',
    CODE_EDITOR_OPEN: 'code_editor_open',
    CODE_EDITOR_RUN: 'code_editor_run',
    CODE_EDITOR_SAVE: 'code_editor_save',
    CREATE_DONE: 'create_done',
    CREATE: 'create',
    EDIT: 'edit',
    ENTITY_CREATE_DONE: 'entity_create_done',
    ENTITY_COPY: 'entity_copy',
    ENTITY_VIEW: 'entity_view',
    ENTITY_EDIT: 'entity_edit',
    ENTITY_CREATE_STEP_1: 'entity_create_step_1',
    ENTITY_CREATE_STEP_2: 'entity_create_step_2',
    ENTITY_CREATE_STEP_3: 'entity_create_step_3',
    ENTITY_SEARCH: 'entity_search',
    ENTITY_TRANSITION: 'entity_transition',
    GENERAL_NODE_BOT: 'general_node_domain',
    GENERAL_NODE_STORY: 'general_node_story',
    GENERAL_RESPONSES_EDIT: 'general_responses_edit',
    HIDE_INACTIVE: 'hide_inactive',
    MOUSE_OVER: 'mouse over',
    NAVIGATION: 'Navigation',
    NODE_CONTEXT_MENU_OPEN: 'node_context_menu_open',
    NODE_EDIT: 'node_edit',
    NODE_INTEGRATIONS_EDIT: 'node_integrations_edit',
    NODE_OPEN: 'node_open',
    NODE_PRIORITY_EDIT: 'node_priority_edit',
    NODE_PRIORITY_VIEW: 'node_priority_view',
    OUTPUT_NODE_OPEN: 'output_node_open',
    OUTPUT_NODE_CREATE: 'output_node_create',
    OUTPUT_NODE_SAVE: 'output_node_save',
    OUTPUT_NODE_ADD_ENTITY: 'output_node_add_entity',
    OUTPUT_STATIC_CONNECTION_ENTITY_TAB: 'output_static_connection_entity_tab',
    PROTIP: 'protip',
    SAVE_NODE: 'save_node',
    SEARCH: 'search',
    SELECT: 'select',
    SHOW_INACTIVE: 'show_inactive',
    STORY_ACTIVATE: 'story_activate',
    STORY_CREATE: 'story_create',
    STORY_DEACTIVATE: 'story_deactivate',
    SUBSTORY_CREATE: 'substory_create',
    SYNONYMS_EDIT: 'synonyms_edit',
    TAG_EDIT: 'tag_edit',
    TASK_TRANSFER: 'task_transfer',
    TEMPLATESIDEBAR_CLOSE: 'template_sidebar_close',
    TEMPLATESIDEBAR_OPEN: 'template_sidebar_open',
    USE_TEMPLATE: 'use_template',
    VIEW_TEMPLATE: 'view_template',
    TESTCHAT_CLOSE: 'testchat_close',
    TESTCHAT_DEBUG: 'testchat_debug',
    TESTCHAT_OPEN: 'testchat_open',
    TOOLTIP_CLICKED: 'tooltip_clicked',
    USER_SAYS_EDIT: 'user_says_edit',
    SELECT_INTEGRATION_TYPE: 'select_integration_type',
    NODE_CLICKED: 'node_clicked',
    RECENTER: 'recenter',
    VIEW_DEBUG_LOGS: 'view_debug_logs',
    CHANGE_DEBUG_TAB: 'change_debug_tab',
    OPEN_DEBUG_LINK: 'open_link_in_debug',

    BOT_GLOSSARY_DOWNLOAD: 'bot_glossary_download',
    BOT_GLOSSARY_UPLOAD: 'bot_glossary_upload',
    SMART_VARIANTS_AVAILABLE: 'smart_variants_available',
    SMART_VARIANTS_TRIGGERED: 'smart_variants_triggered',
    TRANSFER_WITHOUT_SMART_VARIANTS: 'transfer_without_smart_variants',
    BLUE_STATUS_ICON_CLICKED: 'blue_status_icon_clicked',
    GREEN_STATUS_ICON_CLICKED: 'green_status_icon_clicked',
    SEARCH_SMART_SKILL_SEARCHED: 'Search Smart Skill Searched',
  },
  VALUE: {
    SINGLE_CLICK: 1,
  },
  LABEL: {
    ACTIVE_BOT_LIST_CHANGED: 'bot_add_bizmngr',
    ADD_ENTITY_FILTER_VALUE: 'add_entity_filter_value',
    ADD_FINAL_RESPONSE: 'add_final_response',
    ADD_FOLLOWUP: 'add_followup',
    ADD_VARIANT: 'add_variant',
    BOT_ADD: 'domain_add',
    BOT_CREATED: 'bot_created',
    BOT_DEACTIVATE: 'domain_deactivate',
    BOT_QA: 'domain_qa',
    BOT_VIEW: 'domain_view',
    BUSINESS_NAME_EDITED: 'business_name_edited',
    BUSINESS_PREVIEW_TEXT_EDITED: 'business_preview_text_edited',
    CITY_CHANGED: 'city_changed',
    CODE_EDITOR_OPEN: 'code_editor_open',
    CODE_EDITOR_SAVE: 'code_editor_save',
    CODE_EDITOR_RUN: 'code_editor_run',
    DEFAULT_BOT_CHANGED: 'defaultbot_change',
    DELETE_ENTITY_FILTER_VALUE: 'delete_entity_filter_value',
    EDIT_TESTBUSINESS: 'edit_testbusiness',
    EDIT_TESTPARTNER: 'edit_testpartner',
    FALLBACK_BOT_CHANGED: 'fallbackbot_change',
    HSL_ADD_BUTTON: 'add_button',
    HSL_ADD_CAROUSEL: 'add_carousel',
    HSL_ADD_IMAGE: 'add_image',
    HSL_ADD_JSON: 'add_json',
    HSL_ADD_TEXT_QR: 'add_text_quickreplis',
    NEW_BUSINESS_NEW_PARTNER: 'New bot added to new business, new partner',
    NEW_BUSINESS_OLD_PARTNER: 'New bot added to new business, existing partner',
    OLD_BUSINESS_NEW_PARTNER: 'New bot added to existing business, new partner',
    OLD_BUSINESS_OLD_PARTNER:
      'New bot added to existing business, existing partner',
    ORDER_CHANGED: 'order_changed',
    OTP_VERIFICATION_CHANGED: 'opt_verification_changed',
    PROTIP_CLICK: 'protip_click',
    STORY_ADD: 'story_add',
    STORY_VIEW: 'story_view',
    TAG_ADD: 'tag_add',
    TAG_REMOVE: 'tag_remove',
    TASK_ADDED: 'task_added',
    TOOLTIP_OPEN: 'tooltip_open',
    INTEGRATION_TYPE_ENTITY: 'integration-type-entity-function',
    INTEGRATION_TYPE_API: 'integration-type-api',
    INTEGRATION_TYPE_CUSTOM_CODE: 'integration-type-custom-code',
    DEBUG_LOGS_OPEN: 'open_debug_logs',
    DEBUG_OPEN_BUSINESS: 'open_business',
    DEBUG_OPEN_BOT: 'open_bot',
    DEBUG_OPEN_NODE: 'open_node',

    BOT_GLOSSARY_DOWNLOAD: 'download_bot_glossary',
    BOT_GLOSSARY_UPLOAD: 'upload_bot_glossary',
  },
};

export const FIELD_TO_GA_LABEL_MAPPING = {
  testBusiness: GOOGLE_ANALYTICS.LABEL.EDIT_TESTBUSINESS,
  client: GOOGLE_ANALYTICS.LABEL.EDIT_TESTPARTNER,
};
